uvex-search-box {
  display: block;
}
uvex-search-box form {
  position: relative;
  width: 100%;
}
uvex-search-box .btn-icon {
  position: absolute;
  right: 6px;
  top: 3px;
}
uvex-search-box .btn-icon svg {
  fill: var(--search-box-icon-color, #fff);
}
uvex-search-box input {
  height: 45px;
  padding: 0.625rem 3.75rem 0.625rem 1.375rem;
  background: var(--search-box-background, #000);
  border: 1px solid var(--search-box-border-color, #000);
  width: 100%;
  color: var(--search-box-color, #fff);
  outline: 0;
  caret-color: var(--form-control-caret-color, #FF6600);
}
uvex-search-box input::placeholder {
  color: var(--search-box-color, #fff);
}
uvex-search-box input:focus + ul {
  display: block;
}
uvex-search-box input:focus + .btn-icon svg {
  fill: var(--search-box-icon-color, #FF6600);
}
uvex-search-box ul {
  display: none;
  position: absolute;
  top: 45px;
  left: 0;
  right: 0;
  float: left;
  text-align: left;
  list-style: none;
  z-index: 1000;
  margin: 0;
  padding: 0;
  background: #292929;
}
uvex-search-box li {
  color: #fff;
  padding: 0.625rem 1.375rem;
  cursor: pointer;
}
uvex-search-box li:hover, uvex-search-box li.active {
  background-color: var(--search-box-icon-color, #FF6600);
}

.header uvex-search-box {
  display: flex;
  justify-content: flex-end;
  transition: opacity 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: absolute;
  top: 5px;
  left: 15px;
  opacity: 0;
  z-index: -1;
  width: calc(100vw - 80px);
}
@media (min-width: 544px) {
  .header uvex-search-box {
    left: 130px;
    width: calc(100vw - 195px);
  }
}
@media (min-width: 768px) {
  .header uvex-search-box {
    top: 17px;
  }
}
@media (min-width: 992px) {
  .header uvex-search-box {
    left: calc(50% - 335px);
    width: 750px;
  }
  .header uvex-search-box .btn-icon {
    right: 8px;
  }
}
@media (min-width: 1200px) {
  .header uvex-search-box {
    left: calc(50% - 435px);
    width: 950px;
  }
}
@media (min-width: 544px) {
  .layout-heckel .header uvex-search-box {
    left: 230px;
    width: calc(100vw - 295px);
  }
}
@media (min-width: 992px) {
  .layout-heckel .header uvex-search-box {
    left: calc(50% - 240px);
    width: 655px;
  }
}
@media (min-width: 1200px) {
  .layout-heckel .header uvex-search-box {
    left: calc(50% - 335px);
    width: 850px;
  }
}
@media (min-width: 544px) {
  .layout-filtral .header uvex-search-box {
    left: 175px;
    width: calc(100vw - 240px);
  }
}
@media (min-width: 992px) {
  .layout-filtral .header uvex-search-box {
    left: calc(50% - 300px);
    width: 716px;
  }
}
@media (min-width: 1200px) {
  .layout-filtral .header uvex-search-box {
    left: calc(50% - 385px);
    width: 900px;
  }
}
.header uvex-search-box form {
  transition: max-width 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  max-width: 80px;
}
.header uvex-search-box.active {
  opacity: 1;
  z-index: 1;
}
.header uvex-search-box.active form {
  max-width: 100%;
}